import React from 'react';
import {Table, Button} from 'semantic-ui-react';
import {connect} from 'react-redux';
import {Actions} from '../../../common/actions';
import {convertDateToSpecificFormat} from '../../../common/util/date';

class TableSemantic extends React.Component {
  handleDeleteItem = (id) => {
    this.props.deleteBudgetDate(id);
  };

  render() {
    const {dates} = this.props;
    return (
      <Table celled>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell>No.</Table.HeaderCell>
            <Table.HeaderCell>Fecha Inicio</Table.HeaderCell>
            <Table.HeaderCell>Fecha final</Table.HeaderCell>
            <Table.HeaderCell>Eliminar</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {dates &&
            dates.map((date, index) => {
              return (
                <Table.Row key={date.id}>
                  <Table.Cell>{index + 1}</Table.Cell>
                  <Table.Cell>{convertDateToSpecificFormat(date.startDate)}</Table.Cell>
                  <Table.Cell>{convertDateToSpecificFormat(date.endDate)}</Table.Cell>
                  <Table.Cell>
                    <Button onClick={() => this.handleDeleteItem(date.id)} primary icon="trash" />
                  </Table.Cell>
                </Table.Row>
              );
            })}
        </Table.Body>
      </Table>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  const {loading} = state.budgets;
  return {
    loading,
  };
};

const {deleteBudgetDate} = Actions;

export default connect(
  mapStateToProps,
  {
    deleteBudgetDate,
  }
)(TableSemantic);
